import { useMemo } from 'react';
import useResidentQuery from './useResidentQuery';
import { buildHouseholdPendingMembers } from './useHouseholdPendingMembersQuery.helpers';

/**
 * React Query replacement for ResidentProfile/selectors.js's
 * getHouseholdPendingMembers — the Pending Applicant / Denied (canceled)
 * applicant list for a household's Household-card link and Mini-Profile
 * access.
 *
 * Reuses useResidentQuery (same query key/cache as useHouseholdMembersQuery)
 * rather than issuing a second network request.
 */
const useHouseholdPendingMembersQuery = ({
  organizationId,
  propertyId,
  residentId,
  options = {},
}) => {
  const residentQuery = useResidentQuery({
    organizationId,
    propertyId,
    residentId,
    options,
  });

  const pendingMembers = useMemo(() => {
    if (!residentQuery.data) return [];
    return buildHouseholdPendingMembers({
      pendingApplicants:
        residentQuery.data?.applicants?.pendingApplicants ?? [],
      canceledApplicants:
        residentQuery.data?.applicants?.canceledApplicants ?? [],
    });
  }, [residentQuery.data]);

  return {
    data: pendingMembers,
    isLoading: residentQuery.isLoading,
    isFetching: residentQuery.isFetching,
    isError: residentQuery.isError,
  };
};

export default useHouseholdPendingMembersQuery;
